import { sttEvents } from "./speech.service";

export interface IWindow extends Window {
  webkitSpeechRecognition: any;
  SpeechRecognition: any;
}

const { webkitSpeechRecognition, SpeechRecognition } = window as any;
const recognition = new webkitSpeechRecognition() || new SpeechRecognition();

class SpeechRecognitionConfig {
  interval: any;
  i: number = 0;

  getTranscript(event: any): void {
    let { resultIndex, results } = event;
    for (this.i = resultIndex; this.i < results.length; this.i++) {
      if (results[this.i].isFinal) {
        const result = results[this.i][0].transcript;
        sttEvents(result);
        setTimeout(() => {
          recognition.stop();
        }, 5000);
      }
    }
  }
  startRec(): void {
    try {
      recognition.lang = "pt-BR";
      recognition.interimResults = true;
      recognition.start();
    } catch (error) {
      recognition.stop();
    }
  }
  onResultRec(): void {
    recognition.onresult = (event) => {
      this.getTranscript(event);
    };
  }
  onSpeechEndRec(): void {
    recognition.onspeechend = () => {
      this.startRec();
    };
  }
  onEndRec(): void {
    recognition.onend = () => {
      this.startRec();

      // window.onfocus = () => {
      //   this.startRec();
      // };
      // window.onblur = () => {
      //   recognition.stop();
      // };
    };
  }
  onErrorRec(): void {
    recognition.onerror = () => {
      setTimeout(() => {
        this.startRec();
      }, 200);
    };
  }
  recEvents(): void {
    this.onResultRec();
    this.onSpeechEndRec();
    this.onEndRec();
    this.onErrorRec();
  }
}
export { SpeechRecognitionConfig, recognition };
